

























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {DisplayEnum} from '@/types/enum';
import {CheckboxDataType} from '@/types/product';

@Component
export default class ProductPopSearchCheckbox extends Vue {
  @Prop({
    required: true,
    default: () => {
      return [];
    },
    type: Array
  })
  private readonly saleStatusList!: DisplayEnum[];

  @Prop({
    required: true,
    default: () => {
      return [];
    },
    type: Array
  })
  private readonly saleSettingStatusList!: DisplayEnum[];

  @Prop({
    required: false,
    default: () => {
      return [];
    },
    type: Array
  })
  private readonly saleDisabledData?: string[];

  @Prop({
    required: true,
    default: () => {
      return [];
    },
    type: Array
  })
  private readonly saleStatusData!: string[];

  @Prop({
    required: true,
    default: () => {
      return [];
    },
    type: Array
  })
  private readonly saleSettingStatusData!: string[];

  @Prop({required: false, default: false, type: Boolean})
  private readonly isAllDisabled?: boolean;

  private statusCheckList: string[] = [];
  private settingCheckList: string[] = [];

  public get allPossibleStatusCheck(): boolean { // 체크 가능한 항목이 모두 선택되었는지 여부
    return this.statusCheckList.length === this.saleStatusList.filter((item: DisplayEnum): boolean => !this.saleDisabledData.includes(item.value)).length;
  }

  public get allStatusCheck(): boolean { // 체크 불가능 여부 상관없이, 체크 후보군 모두 선택되었는지 여부
    return this.statusCheckList.length === this.statusRenderData.length;
  }

  public get allPossibleSettingCheck(): boolean { // 체크 가능한 항목이 모두 선택되었는지 여부
    return this.settingCheckList.length === this.saleSettingStatusList.filter((item: DisplayEnum): boolean => !this.saleDisabledData.includes(item.value)).length;
  }

  public get allSettingCheck(): boolean { // 체크 불가능 여부 상관없이, 체크 후보군 모두 선택되었는지 여부
    return this.settingCheckList.length === this.settingRenderData.length;
  }

  private get allSaleStatusList(): DisplayEnum[] {
    return this.saleStatusList.concat(this.saleSettingStatusList);
  }

  public get allCheck(): boolean {
    return this.allSaleStatusList.length - this.saleDisabledData.length === this.statusCheckList.length + this.settingCheckList.length;
  }

  public get allCheckOfActual(): boolean {
    return this.allSaleStatusList.length === this.statusCheckList.length + this.settingCheckList.length;
  }

  public get allCheckedStatusList(): string[] {
    return this.statusCheckList.concat(this.settingCheckList);
  }

  private get statusRenderData(): CheckboxDataType[] {
    return this.saleStatusList.map(
      (item: DisplayEnum): CheckboxDataType => {
        const isSaleDisabled = this.saleDisabledData.includes(item.value);
        const disabled = isSaleDisabled ? true : this.isAllDisabled ? true : false;
        const checked = this.statusCheckList.includes(item.value) && !isSaleDisabled ? true : false;
        return {...item, disabled, checked};
      }
    );
  }

  private get settingRenderData(): CheckboxDataType[] {
    return this.saleSettingStatusList.map(
      (item: DisplayEnum): CheckboxDataType => {
        const isSaleDisabled = this.saleDisabledData.includes(item.value);
        const disabled = isSaleDisabled ? true : this.isAllDisabled ? true : false;
        const checked = this.settingCheckList.includes(item.value) && !isSaleDisabled ? true : false;
        return {...item, disabled, checked};
      }
    );
  }

  private get saleStatusCheckedData(): string[] {
    const items = this.saleStatusList.filter((item: DisplayEnum): boolean => this.statusCheckList.includes(item.value));
    if (items) {
      return items.map((item: DisplayEnum): string => item.value);
    }
    return [];
  }

  private get saleSettingStatusCheckedData(): string[] {
    const items = this.saleSettingStatusList.filter((item: DisplayEnum): boolean => this.settingCheckList.includes(item.value));
    if (items) {
      return items.map((item: DisplayEnum): string => item.value);
    }
    return [];
  }

  @Watch('isAllDisabled')
  onIsAllDisabledChange(newVal: boolean) {
    if (newVal) {
      this.statusCheckList = [];
      this.settingCheckList = [];
    }
  }

  @Watch('saleStatusData')
  onSaleStatusDataChange() {
    this.init();
  }

  @Watch('saleSettingStatusData')
  onSaleSettingStatusData() {
    this.init();
  }

  @Watch('saleDisabledData')
  onSaleDisabledData() {
    this.init();
  }

  private isStatusItemDisabled: boolean = false;
  private isSettingItemDisabled: boolean = false;

  private statusHandler(event: any) {
    this.isSettingItemDisabled = false;
    const {checked} = event.target;
    if (checked) {
      this.statusCheckList = this.saleStatusList.filter((item: DisplayEnum): boolean => !this.saleDisabledData.includes(item.value)).map((item: DisplayEnum): string => item.value);
    } else {
      this.statusCheckList = [];
    }
  }

  private settingHandler(event: any) {
    this.isStatusItemDisabled = false;
    const {checked} = event.target;
    if (checked) {
      this.settingCheckList = this.saleSettingStatusList.filter((item: DisplayEnum): boolean => !this.saleDisabledData.includes(item.value)).map((item: DisplayEnum): string => item.value);
    } else {
      this.settingCheckList = [];
    }
  }

  private statusCheckListChange() {
    if (this.statusCheckList.includes('END_SALE') && this.statusCheckList.length === 1) {
      this.isSettingItemDisabled = true;
      this.settingCheckList = [];
    } else {
      this.isSettingItemDisabled = false;
    }
  }

  private settingCheckListChange() {
    if (this.settingCheckList.includes('PROHIBITION_SALE') && this.settingCheckList.length === 1) {
      this.isStatusItemDisabled = true;
      this.statusCheckList = [];
    } else {
      this.isStatusItemDisabled = false;
    }
  }

  private init() {
    this.statusCheckList = this.saleStatusData.filter((item: string): boolean => !this.saleDisabledData.includes(item));
    this.settingCheckList = this.saleSettingStatusData.filter((item: string): boolean => !this.saleDisabledData.includes(item));
    this.statusCheckListChange();
    this.settingCheckListChange();
  }

  private created() {
    this.init();
  }
}
